'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Assert = require('./utility/Assert');

var _Assert2 = _interopRequireDefault(_Assert);

var _Strings = require('./utility/Strings');

var _Strings2 = _interopRequireDefault(_Strings);

var _Version = require('./Version');

var _Version2 = _interopRequireDefault(_Version);

var _Constants = require('./Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _PluginState = require('./PluginState');

var _PluginState2 = _interopRequireDefault(_PluginState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 插件配置解析结果
 * 
 * @export
 * @class PluginConfiguration
 */
var PluginConfiguration = function () {
    /**
     * 创建一个插件配置解析类
     * 
     * @ignore
     * @param {string} pluginConfigFile 插件配置文件plugin.json文件路径 
     * @memberof PluginConfiguration
     */
    function PluginConfiguration(pluginConfigFile) {
        (0, _classCallCheck3.default)(this, PluginConfiguration);

        if (pluginConfigFile === undefined) {
            return;
        }

        _Assert2.default.notExists(pluginConfigFile);

        this._pluginConfigFile = pluginConfigFile;
        this._pluginConfigurationData = require(pluginConfigFile);

        this._dependencies = [];
        this._services = [];
        this._extensions = [];

        _Assert2.default.notNull('pluginConfiguration', this._pluginConfigurationData);
        _Assert2.default.notEmpty('id', this._pluginConfigurationData.id);

        this.parseBasic = this.parseBasic.bind(this);
        this.parseStoppable = this.parseStoppable.bind(this);
        this.parseDependencies = this.parseDependencies.bind(this);
        this.parseServices = this.parseServices.bind(this);
        this.parseExtensions = this.parseExtensions.bind(this);

        this.parseBasic();
        this.parseDependencies();
        this.parseServices();
        this.parseExtensions();
    }

    /**
     * 获取plugin.json对应的JSON对象
     * 
     * @type {Object}
     * @readonly
     * @memberof PluginConfiguration
     */


    (0, _createClass3.default)(PluginConfiguration, [{
        key: 'parseBasic',


        /**
         * 解析基本信息
         * 
         * @memberof PluginConfiguration
         */
        value: function parseBasic() {
            this._id = this._pluginConfigurationData.id;
            this._name = this._pluginConfigurationData.name;
            this._activator = this._pluginConfigurationData.activator;

            if (!_Strings2.default.hasText(this._name)) {
                this._name = this._id;
            }

            this._description = this._pluginConfigurationData.description;

            if (!_Strings2.default.hasText(this._description)) {
                this._description = this._name;
            }

            this._version = new _Version2.default(this._pluginConfigurationData.version);

            this._startLevel = parseInt(this._pluginConfigurationData.startLevel || _Constants2.default.defaultStartLevel);
            if (isNaN(this._startLevel)) {
                throw new Error('The startLevel is not legal number of ' + this.pluginConfigFileFullPath + '.');
            }

            if (this._pluginConfigurationData.initializedState === 'installed') {
                this._initializedState = _PluginState2.default.INSTALLED;
            } else if (this._pluginConfigurationData.initializedState === undefined || this._pluginConfigurationData.initializedState === 'active') {
                this._initializedState = _PluginState2.default.ACTIVE;
            } else {
                throw new Error('The initializedState must be installed or active of ' + this.pluginConfigFileFullPath + '.');
            }

            this.parseStoppable();
        }
    }, {
        key: 'parseStoppable',
        value: function parseStoppable() {
            var stoppable = this._pluginConfigurationData.stoppable;
            if (stoppable === undefined || stoppable === null) {
                stoppable = true;
            } else {
                stoppable = !!stoppable;
            }
            this._stoppable = stoppable;
        }

        /**
         * 解析依赖关系
         * 
         * @memberof PluginConfiguration
         */

    }, {
        key: 'parseDependencies',
        value: function parseDependencies() {
            if (!(this._pluginConfigurationData.dependencies && this._pluginConfigurationData.dependencies instanceof Array)) {
                return;
            }

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this._pluginConfigurationData.dependencies), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var dependency = _step.value;

                    if (!_Strings2.default.hasText(dependency.id)) {
                        throw new Error('The dependent plugin id can not be empty of ' + this.pluginConfigFileFullPath + '.');
                    }
                    this._dependencies.push({ id: dependency.id, version: new _Version2.default(dependency.version) });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }

        /**
         * 解析服务
         * 
         * @memberof PluginConfiguration
         */

    }, {
        key: 'parseServices',
        value: function parseServices() {
            if (!(this._pluginConfigurationData.services && this._pluginConfigurationData.services instanceof Array)) {
                return;
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(this._pluginConfigurationData.services), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var service = _step2.value;

                    if (!_Strings2.default.hasText(service.name)) {
                        throw new Error('The service name can not be empty of ' + this.pluginConfigFileFullPath + '.');
                    }
                    if (!_Strings2.default.hasText(service.service)) {
                        throw new Error('The service can not be empty of ' + this.pluginConfigFileFullPath + '.');
                    }
                    if (!service.properties) {
                        service.properties = {};
                    }
                    this._services.push({ name: service.name, service: service.service, properties: service.properties });
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }

        /**
         * 解析扩展
         * 
         * @memberof PluginConfiguration
         */

    }, {
        key: 'parseExtensions',
        value: function parseExtensions() {
            if (!(this._pluginConfigurationData.extensions && this._pluginConfigurationData.extensions instanceof Array)) {
                return;
            }

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = (0, _getIterator3.default)(this._pluginConfigurationData.extensions), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var extension = _step3.value;

                    if (!_Strings2.default.hasText(extension.id)) {
                        throw new Error('The extension id can not be empty of ' + this.pluginConfigFileFullPath + '.');
                    }
                    if (!extension.data) {
                        throw new Error('The extension data can not be null of ' + this.pluginConfigFileFullPath + '.');
                    }
                    this._extensions.push({ 'id': extension.id, 'data': extension.data });
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
    }, {
        key: 'pluginConfigurationData',
        get: function get() {
            return this._pluginConfigurationData;
        }

        /**
         * 插件配置文件plugin.json的路径
         * 
         * @readonly
         * @memberof PluginConfiguration
         */

    }, {
        key: 'pluginConfigFileFullPath',
        get: function get() {
            return this._pluginConfigFile;
        }

        /**
         * 插件id
         * 
         * @type {string}
         * @readonly
         * @memberof PluginConfiguration
         */

    }, {
        key: 'id',
        get: function get() {
            return this._id;
        }

        /**
         * 插件名称
         * 
         * @type {string}
         * @readonly
         * @memberof PluginConfiguration
         */

    }, {
        key: 'name',
        get: function get() {
            return this._name;
        }

        /**
         * 插件描述
         * 
         * @type {string}
         * @readonly
         * @memberof PluginConfiguration
         */

    }, {
        key: 'description',
        get: function get() {
            return this._description;
        }

        /**
         * 插件启动级别，默认为50，越小越早启动
         * 
         * @type {number}
         * @readonly
         * @memberof PluginConfiguration
         */

    }, {
        key: 'startLevel',
        get: function get() {
            return this._startLevel;
        }

        /**
         * 插件初始状态，默认为PluginState.ACTIVE
         * 
         * @type PluginState
         * @readonly
         * @memberof PluginConfiguration
         */

    }, {
        key: 'initializedState',
        get: function get() {
            return this._initializedState;
        }

        /**
         * 插件版本
         * 
         * @type {Version}
         * @readonly
         * @memberof PluginConfiguration
         */

    }, {
        key: 'version',
        get: function get() {
            return this._version;
        }

        /**
         * 插件激活器
         * 
         * @readonly
         * @memberof PluginConfiguration
         */

    }, {
        key: 'activator',
        get: function get() {
            return this._activator;
        }

        /**
         * 是否允许停止，默认为true
         * 
         * @readonly
         * @memberof PluginConfiguration
         */

    }, {
        key: 'stoppable',
        get: function get() {
            return this._stoppable;
        }

        /**
         * 依赖关系的JSON格式
         * 
         * @type {Object[]}
         * @readonly
         * @memberof PluginConfiguration
         */

    }, {
        key: 'dependencies',
        get: function get() {
            return this._dependencies;
        }

        /**
         * 服务的JSON格式
         * 
         * @type {Object[]}
         * @readonly
         * @memberof PluginConfiguration
         */

    }, {
        key: 'services',
        get: function get() {
            return this._services;
        }

        /**
         * 扩展的JSON格式
         * 
         * @type {Object[]}
         * @readonly
         * @memberof PluginConfiguration
         */

    }, {
        key: 'extensions',
        get: function get() {
            return this._extensions;
        }
    }]);
    return PluginConfiguration;
}();

exports.default = PluginConfiguration;
//# sourceMappingURL=PluginConfiguration.js.map